import * as Sentry from "@sentry/react";
import { useCallback } from "react";

declare const sensors: any;

const isProd = process.env.NODE_ENV === "production";

const useLogCustomize = () => {
  const sensorsTrack = useCallback(
    (key: string, params: Record<string, any>) => {
      try {
        if (isProd && sensors) {
          const modifiedParams = Object.fromEntries(
            Object.entries(params).map(([key, value]) => [`bf_${key}`, value]),
          );
          sensors?.track(key, modifiedParams);
        }
      } catch (error) {
        Sentry?.captureException(error);
      }
    },
    [],
  );

  return {
    sensorsTrack,
  };
};

export default useLogCustomize;
